<template>
	<div class="staff-new">
		<div v-show="!isSubmitCompleted">
			<div class="mb-10 tm">※必須項目</div>

			<div class="input-wrap">
				<div class="input-title">ログインID ※ <span class="loginid-notice">半角英数のみ。スペース不可</span></div>
				<div class="sv-field">
					<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'loginId') }" v-model="loginId" placeholder="半角英数"/>
				</div>
				<span class="error-message" v-show="errors.loginId">{{ errors.loginId }}</span>
			</div>

			<div class="input-wrap">
				<div class="input-title require">名前（姓/名）</div>
				<div class="sv-field name-horizontal">
					<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'nameSei') }" v-model="nameSei"/>
					<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'nameMei') }" v-model="nameMei"/>
				</div>
				<div class="error-message" v-show="errors.nameSei">（姓）{{ errors.nameSei }}</div>
				<div class="error-message" v-show="errors.nameMei">（名）{{ errors.nameMei }}</div>
			</div>

			<div class="input-wrap">
				<div class="input-title require">フリガナ（セイ/メイ）</div>
				<div class="sv-field name-horizontal">
					<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'nameSeiKana') }" v-model="nameSeiKana"/>
					<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'nameMeiKana') }" v-model="nameMeiKana"/>
				</div>
				<div class="error-message" v-show="errors.nameSeiKana">（セイ）{{ errors.nameSeiKana }}</div>
				<div class="error-message" v-show="errors.nameMeiKana">（メイ）{{ errors.nameMeiKana }}</div>
			</div>

			<div class="input-wrap">
				<div class="input-title require">性別</div>
				<div class="sv-field">
					<radio-picker :options="genders" v-model="genderId"></radio-picker>
				</div>
			</div>

			<div class="input-wrap">
				<div class="input-title">生年月日（西暦/月/日）</div>
				<div class="sv-field">
					<date-select :dateProvided="birthday" :hasEmptyOption="true" :isTextShow="false" :years="years" @change="onBirthdayInut"></date-select>
				</div>
				<span class="error-message" v-show="errors.birthday">{{ errors.birthday }}</span>
			</div>

			<div class="input-wrap">
				<div class="input-title">メールアドレス</div>
				<div class="sv-field">
					<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'email') }" v-model="email"/>
				</div>
				<span class="error-message" v-show="errors.email">{{ errors.email }}</span>
			</div>

			<div class="input-wrap">
				<div class="input-title require">パスワード</div>
				<div class="sv-field">
					<input v-if="isPasswordShow" :placeholder="$consts.PWD_PH" type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'password') }" v-model="password"/>
					<input v-else type="password" :placeholder="$consts.PWD_PH" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'password') }" v-model="password"/>
				</div>
				<div class="error-message" v-show="errors.password">{{ errors.password }}</div>
				<sv-checkbox class="mt-10" v-model="isPasswordShow">パスワードを表示</sv-checkbox>
			</div>

			<div class="input-wrap">
				<div class="input-title">プロフィール画像</div>
				<div class="sv-field" style="text-align: center;">
					<img class="preview" :src="require('@/assets/user_nophoto.svg')" v-show="!image" :style="{ 'max-width': previewW + 'px' }">
					<image-picker :isDeleteButtonShow="false" :previewUrl="image" :isLoading="isImageLoading" :previewW="previewW" @file-change="onImageChange"></image-picker>
				</div>
			</div>

			<div v-if="!$route.params.teamId" class="input-wrap">
				<div class="input-title require">初期チーム</div>
				<div class="sv-field">
					<b-select v-model="teamId">
						<option
							v-for="row in teams"
							:value="row.id"
							:key="row.id">
							{{ row.name }}
						</option>
					</b-select>
				</div>
			</div>

			<div class="notice mt-50">ご登録の前には必ず「利用規約」をお読みいただき、同意の上でご登録ください。</div>

			<div style="text-align: center">
				<sv-checkbox class="mt-30 mb-40" v-model="isAgree"><a class="agree" :href="$utils.getOpenBrowserUrl($utils.getHostName() + '/terms-of-service.html')" :target="$utils.isApp() ? false : '_blank'">利用規約</a>に同意する</sv-checkbox>
			</div>

			<horizontal-buttons v-if="!$utils.isApp()" okButtonTitle="確認" :isOkButtonLoading="isSubmitLoading" :isOkButtonEnable="isAgree" @ok-click="isModalActive = true" @cancel-click="$router.go(-1)"></horizontal-buttons>
			<b-button v-else type="is-primary" rounded class="max-w-button" :disabled="!isAgree" @click="isModalActive = true">確認</b-button>

			<b-modal :active.sync="isModalActive">
				<confirm-modal title="登録確認" body="新規登録します。よろしいですか？" okButtonTitle="登録する" @ok-click="onOkClick" @cancel-click="isModalActive = false"></confirm-modal>
			</b-modal>
		</div>

		<div v-show="isSubmitCompleted">
			ご登録が完了しました。<a :href="$utils.getHostName() + '/login'">こちら</a>からWeb版をご利用頂くか、アプリをダウンロードしてご利用ください。
		</div>
	</div>
</template>

<script>
import DateSelect from '@/components/DateSelect'
import RadioPicker from '@/components/RadioPicker'
import SvCheckbox from '@/components/SvCheckbox'
import ImagePicker from '@/components/ImagePicker'
import HorizontalButtons from '@/components/HorizontalButtons'
import ConfirmModal from '@/components/ConfirmModal'

export default {
	name: 'StaffNew',
	components: {
		DateSelect,
		SvCheckbox,
		RadioPicker,
		ImagePicker,
		HorizontalButtons,
		ConfirmModal,
	},
	data () {
		return {
			isSubmitCompleted: false,
			isModalActive: false,
			nameSei: '',
			nameMei: '',
			nameSeiKana: '',
			nameMeiKana: '',
			email: '',
			loginId: '',
			password: '',
			genderId: 1,
			birthday: '1989-01-01',
			teamId: '',
			isPasswordShow: false,
			isImageLoading: false,
			isAgree: false,
			isSubmitLoading: false,
			errors: {
				nameSei: '',
				nameMei: '',
				nameSeiKana: '',
				nameMeiKana: '',
				email: '',
				loginId: '',
				password: '',
				birthday: '',
			},
			genders: null,
			teams: [],
			years: [],
			image: '',
			previewW: 160,
		}
	},
	created() {
		this.$store.commit('basic', {
			key: 'isFloatingMenuShow',
			value: false,
		});

		if (!this.$utils.isApp()) {
			this.$store.commit('basic', {
				key: 'isNavBarShow',
				value: true,
			});
			this.$store.commit('basic', {
				key: 'isNavBarMenuShow',
				value: false,
			});
		}
		this.teamId = this.$route.params.teamId || '';
	},
	mounted() {
		this.years = this.$utils.createYearSelectOption();
		this.init();
	},
	methods: {
		onOkClick: async function() {
			this.isModalActive = false;
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isSubmitLoading = true;
			let data = {
				"id": '',
				"name_sei": this.nameSei,
				"name_mei": this.nameMei,
				"name_sei_kana": this.nameSeiKana,
				"name_mei_kana": this.nameMeiKana,
				"gender_id": this.genderId,
				"birthday": this.birthday,
				"email": this.email,
				"login_id": this.loginId,
				"password": this.password,
				"avatar_main": this.image,
			};
			let st = [this.teamId];
			data.staff_teams = st;
			this.$utils.log(data);

			let ep = 'staffs';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data);
				this.$utils.log(res);
				this.isSubmitCompleted = true
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isSubmitLoading = false;
			}
		},
		onImageChange: function(file) {
			this.uploadImage(file);
		},
		uploadImage: async function(file) {
			this.isImageLoading = true;

			let data = {
				"image": file,
			};
			let ep = 'staffs/avatar';

			try {
				let res = await this.$api.post(ep, data);
				this.$utils.log(res);
				this.image = res.data.url;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isImageLoading = false;
			}
		},
		onBirthdayInut: function(date) {
			this.birthday = date;
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'staffs/screen-for-new';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null);
				this.$utils.log(res);
				this.genders = res.data.genders;
				this.teams = res.data.teams;
				if (!this.$route.params.teamId) this.teamId = this.teams[0].id;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.staff-new {
	font-size: 18px;

	.preview {
		display: block;
		margin: 0 auto;
	}

	.agree {
		color: $skyBlue;
		text-decoration: underline;
	}
}

</style>
